import { putRecord } from './db';
import { getDeviceId } from './device';
import type { ConflictRecord } from './types';

export async function createConflict(input: Omit<ConflictRecord, 'conflict_id' | 'device_id' | 'created_at' | 'status'> & { status?: ConflictRecord['status'] }): Promise<ConflictRecord> {
  const conflict: ConflictRecord = {
    ...input,
    conflict_id: crypto.randomUUID(),
    device_id: getDeviceId(),
    created_at: new Date().toISOString(),
    status: input.status || 'USER_ACTION_REQUIRED',
  };
  await putRecord('conflicts', conflict);
  return conflict;
}
